'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _components = require('../../components');
var _VerificationCodeSection = require('./Sections/VerificationCodeSection');var _VerificationCodeSection2 = _interopRequireDefault(_VerificationCodeSection);
var _PhoneNumberSection = require('./Sections/PhoneNumberSection');var _PhoneNumberSection2 = _interopRequireDefault(_PhoneNumberSection);

var _PhoneVerificationForm = require('./PhoneVerificationForm.scss');var styles = _interopRequireWildcard(_PhoneVerificationForm);
var _helpButton = require('../../../static/icons/help-button.png');var _helpButton2 = _interopRequireDefault(_helpButton);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Styles
var PhoneVerificationForm = function (_Component) {_inherits(PhoneVerificationForm, _Component);function PhoneVerificationForm() {var _temp, _this, _ret;_classCallCheck(this, PhoneVerificationForm);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      showTooltip: false }, _this.


    tooltipHandler = function () {
      _this.setState({ showTooltip: !_this.state.showTooltip });
    }, _temp), _possibleConstructorReturn(_this, _ret);}PhoneVerificationForm.prototype.

  render = function render() {var _this2 = this;
    var phoneNumberSection =
    _react2.default.createElement(_PhoneNumberSection2.default, {
      translate: this.props.translate,
      locale: this.props.locale,
      onChange: this.props.onChange,
      validatePhoneNumber: this.props.validatePhoneNumber,
      sendPhoneNumber: this.props.sendPhoneNumber,
      fetchReCaptchaToken: this.props.fetchReCaptchaToken,
      phoneNumberIsInvalid: this.props.phoneNumberIsInvalid,
      phoneNumberSent: this.props.phoneNumberSent,
      showPhonePreloader: this.props.showPhonePreloader,
      isMobile: this.props.isMobile,
      errorMessage: this.props.errorMessage,
      showErrorMessage: this.props.showErrorMessage,
      doResetCaptcha: this.props.doResetCaptcha,
      phoneNumberAlreadyTaken: this.props.phoneNumberAlreadyTaken,
      isRtl: this.props.isRtl });



    var codeSection = this.props.phoneNumberSent ?
    _react2.default.createElement(_VerificationCodeSection2.default, {
      translate: this.props.translate,
      onChange: this.props.onChange,
      validateCode: this.props.validateCode,
      codeIsValid: this.props.codeIsValid,
      showCodePreloader: this.props.showCodePreloader,
      codeIsVerified: this.props.codeIsVerified,
      isRtl: this.props.isRtl }) :

    null;

    return (
      _react2.default.createElement('div', { className: styles.verificationForm },
        _react2.default.createElement('div', { className: styles.title },
          _react2.default.createElement('span', null, this.props.translate('phoneVerificationMessage')),
          _react2.default.createElement('div', { className: styles.tooltipButton },
            _react2.default.createElement('img', {
              src: _helpButton2.default,
              alt: 'help-icon',
              tabIndex: 0,
              onClick: this.tooltipHandler,
              onBlur: function onBlur() {return _this2.setState({ showTooltip: false });} }),

            this.state.showTooltip ?
            _react2.default.createElement(_components.OMTooltip, {
              msg: this.props.tooltipMsg,
              locale: this.props.locale,
              className: 'phoneVerificationTooltip',
              onClose: this.tooltipHandler }) :
            null)),


        phoneNumberSection,
        _react2.default.createElement(_reactAddonsCssTransitionGroup2.default, {
            transitionName: 'code-section',
            transitionEnterTimeout: 500,
            transitionLeaveTimeout: 400 },

          codeSection)));



  };return PhoneVerificationForm;}(_react.Component);


PhoneVerificationForm.propTypes = {
  translate: _propTypes2.default.func,
  tooltipMsg: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  validateCode: _propTypes2.default.func,
  validatePhoneNumber: _propTypes2.default.func,
  sendPhoneNumber: _propTypes2.default.func,
  fetchReCaptchaToken: _propTypes2.default.func,
  phoneNumberSent: _propTypes2.default.bool,
  codeIsValid: _propTypes2.default.bool,
  codeIsVerified: _propTypes2.default.bool,
  phoneNumberIsInvalid: _propTypes2.default.bool,
  showCodePreloader: _propTypes2.default.bool,
  showPhonePreloader: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  showErrorMessage: _propTypes2.default.bool,
  doResetCaptcha: _propTypes2.default.bool,
  errorMessage: _propTypes2.default.string,
  phoneNumberAlreadyTaken: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool };exports.default =


PhoneVerificationForm;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PhoneVerification/PhoneVerificationForm.js
// module id = 2771
// module chunks = 0